// @ts-expect-error incompatibility with node16 resolution
import type {PortableTextBlock} from '@portabletext/types';
import {ReactNode} from 'react';
import {motion} from 'framer-motion';

type Props = {
  children?: ReactNode;
  node: PortableTextBlock;
};

const lineVars = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.6, 0.05, 0.01, 0.9],
    },
  },
};

export default function Block({children, node}: Props) {
  switch (node.style) {
    case 'h0':
      return (
        <motion.h1 variants={lineVars} className="blockH3">
          {children}
        </motion.h1>
      );
    case 'h1':
      return (
        <motion.h1 variants={lineVars} className="richH1">
          {children}
        </motion.h1>
      );
    case 'h2':
      return (
        <motion.p variants={lineVars} className="richH2">
          {children}
        </motion.p>
      );
    case 'h3':
      return (
        <motion.p variants={lineVars} className="richH3">
          {children}
        </motion.p>
      );
    case 'h4':
      return (
        <motion.p variants={lineVars} className="richH4">
          {children}
        </motion.p>
      );
    case 'h5':
      return (
        <motion.p variants={lineVars} className="richH5">
          {children}
        </motion.p>
      );
    case 'h6':
      return (
        <motion.p variants={lineVars} className="richH6">
          {children}
        </motion.p>
      );
    default:
      return (
        <motion.p variants={lineVars} className="richH7">
          {children}
        </motion.p>
      );
  }
}
